import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {ActionbarItem} from '@catcore/types/base';

const selectorName = 'cat-actionbar';
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: selectorName,
  templateUrl: './actionbar.component.html',
})
export class ActionbarComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input() items: any[] = [];
  @Output() onActivate = new EventEmitter<ActionbarItem>();

  constructor() {
  }

  onItemClick(item: ActionbarItem) {

    this.onActivate.emit(item);

  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/components/actionbar/actionbar.component.ts